import { FormattedMessage, useIntl } from 'react-intl'
import { Outlet, useLocation, useNavigate } from '@tanstack/react-router'

import { Tabs } from '@gto/ui/tabs'

export const RootRoute = () => {
  const intl = useIntl()
  const location = useLocation()
  const navigate = useNavigate()

  const route = location.pathname.split('/').at(-1)

  return (
    <div className="flex flex-col gap-8 sm:gap-6">
      <Tabs.Root
        detached
        value={route ?? null}
        onValueChange={(value) => {
          navigate({
            to: `/app/user/${value}`,
            viewTransition: true,
          }).catch(console.error)
        }}
      >
        <Tabs.List aria-label={intl.formatMessage({ id: 'common.controls.account' })}>
          <Tabs.Tab value="account">
            <FormattedMessage id="common.controls.account" />
          </Tabs.Tab>

          <Tabs.Tab value="settings">
            <FormattedMessage id="common.controls.settings" />
          </Tabs.Tab>
        </Tabs.List>
      </Tabs.Root>

      <Outlet />
    </div>
  )
}
